import { inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  private readonly document = inject(DOCUMENT);

  private originalFavicons: string[] = [];

  setFavicon(favicon: string) {
    const nodeList = this.document.querySelectorAll("link[rel~='icon']");

    const array = Array.from(nodeList);

    array.forEach((l, lIndex) => {
      this.originalFavicons[lIndex] = l.getAttribute('href') || '';
      const el = l as any;
      el.href = favicon;
    });
  }

  resetFavicon() {
    if (this.originalFavicons.length > 0) {
      const nodeList = this.document.querySelectorAll("link[rel~='icon']");

      const array = Array.from(nodeList);
      array.forEach((l, lIndex) => {
        const el = l as any;
        el.href = this.originalFavicons[lIndex];
      });
    }
  }
}
